import gql from 'graphql-tag';

export default gql`
  mutation selectShow(
    $showDate: Date!
    $selectShowDetails: [SelectShowInput!]!
  ) {
    selectShow(showDate: $showDate, selectShowDetails: $selectShowDetails) {
      order {
        status
        __typename
      }
      errors
      __typename
    }
  }
`;
